import { game } from '../main';
import { makeImage } from '../utils/makeImage';
import { OneLineCounter } from '../Components/OneLineCounter';

export class PointsCounter extends Phaser.Group {
  private bg: Phaser.Image;
  private score: number;
  private counterTxt: OneLineCounter;

  constructor(x: number, y: number) {
    super(game);

    this.position.setTo(x, y);
    
    this.bg = makeImage(0, 0, 'bg_numbers_hud', 0.5, this);
    this.score = 0;

    this.counterTxt = new OneLineCounter(0, 0, 'font', 0, 30, 180, 0.5, 0.5);
    this.add(this.counterTxt);
  }

  public increaseScore(increase: number) {
    this.score += increase;
    this.counterTxt.changeAmount(this.score);
  }

  public getScore(): number {
    return this.score;
  }
};
